module.exports = __webpack_public_path__ + "static/media/banner_en_mantenimiento.3cfb4af7.png";